import NiceModal, { useModal } from '@ebay/nice-modal-react'
import type { ReactNode } from 'react'

import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'
import Modal from './modal'

type MessageModalType = {
  message?: ReactNode
  title?: string
  onClick?: (() => void) | null
}

const MessageModal = ({ title, message, onClick }: MessageModalType) => {
  const modal = useModal()

  return (
    <Modal id="message-modal" zIndex={335}>
      {title && (
        <p className="text-2xl lg:text-3xl text-txt text-center font-Avenir-Black mb-5">
          {title}
        </p>
      )}
      {message && (
        <p className="text-[15px] lg:text-xl text-txt text-center font-Avenir-Light [&_span]:font-Avenir-Heavy">
          {message}
        </p>
      )}
      <div className="flx-ctr" style={{ marginTop: '25px' }}>
        <button
          onClick={async () => {
            onClick?.()
            await closeModal(modal)
          }}
          className={classNames(
            'w-[120px] lg:w-[170px] py-[7px] lg:py-2.5 text-lg lg:text-xl text-ok-btn-txt text-center font-Avenir-Light bg-ok-btn-bg',
            'border-[1.5px] border-ok-btn-bg rounded-[22px] lg:rounded-[26px] transition-all duration-200 ease-in-out',
          )}>
          Ok
        </button>
      </div>
    </Modal>
  )
}

export default NiceModal.create(MessageModal)
